import { Center, Fade, Spinner, useColorModeValue } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigation } from "react-router";

interface ILoadingProps {
    center?: true;
    large?: true;
}

export function Loading(props: ILoadingProps) {
    const spinnerColor = useColorModeValue("brand.500", "brand.400");

    const spinner = <Spinner size={props.large ? "xxl" : "md"} thickness="8px" color={spinnerColor} />;

    if (props.center) {
        return <Center my={16}>{spinner}</Center>;
    }
    return spinner;
}

const NAVIGATION_LOADING_DELAY_MS = 100;

export function NavigationLoading(props: ILoadingProps) {
    const navigation = useNavigation();
    const backgroundColor = useColorModeValue("grayAlpha.400", "grayAlpha.700");

    const [visible, setVisible] = useState(false);
    useEffect(() => {
        const navigating = navigation.state !== "idle";
        const timeout = setTimeout(() => setVisible(navigating), navigating ? NAVIGATION_LOADING_DELAY_MS : 0);
        return () => clearTimeout(timeout);
    }, [navigation.state]);

    return (
        <Fade in={visible} unmountOnExit>
            <Center
                position="absolute"
                top={0}
                left={0}
                right={0}
                zIndex={1}
                p={3}
                width="100%"
                height="100%"
                backgroundColor={backgroundColor}
            >
                <Loading large center {...props} />
            </Center>
        </Fade>
    );
}
